import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import LoginImage from '../assets/images/bg-05.webp';
import { useSelector } from 'react-redux';
import { LoaderComponent } from '../components';
import { UnAuthLayoutContainer, UnAuthLayoutMain, UnAuthLayoutWrapper } from '../styles/global-styles';
const Logo = '/logo.webp';

const UnauthLayout = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { isAuthenticated, user } = useSelector((state) => state.loginUserReducer);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (isAuthenticated === undefined) {
            setLoading(true);
        } else if (isAuthenticated) {
            navigate("/");
        } else if (location.pathname === '/otp') {
            if (!user?.is2FAEnabled && !isAuthenticated) {
                navigate('/login');
            } else {
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    }, [isAuthenticated, navigate]); // eslint-disable-line react-hooks/exhaustive-deps

    if (loading) {
        return <LoaderComponent />;
    }

    return (
        <UnAuthLayoutWrapper>
            <UnAuthLayoutMain>
                <UnAuthLayoutContainer className='box-shadow'>

                    {/* image section */}
                    <div className="left" style={{ backgroundImage: `url(${LoginImage})` }} />

                    {/* form section */}
                    <div className='right'>
                        {/* LOGO */}
                        <img src={Logo} alt='Open ACS' className='logo' />
                        <Outlet />
                    </div>
                </UnAuthLayoutContainer>
            </UnAuthLayoutMain>
        </UnAuthLayoutWrapper>
    );
};

export default UnauthLayout;
